export const GruposPaginas = [
  // Terreo
  ["grupo01", "grupo02", "grupo03", "grupo04", "grupo05", "grupo06", "grupo07", "grupo08", "grupo09", "grupo10",
    "grupo29", "grupo54", "grupo55", "grupo56", "grupo57"
  ],

  // Lazer
  ["grupo13", "grupo14", "grupo15", "grupo16", "grupo17", "grupo18", "grupo19", "grupo23", "grupo26", "grupo27", "grupo28", 
    "grupo30", "grupo31", "grupo32", "grupo33", "grupo35", "grupo36", "grupo37", "grupo38", "grupo39"],

  // Apoio 
  ["grupo51", "grupo52"],

  // Rooftop
  ["grupo42", "grupo43", "grupo44", "grupo45", "grupo46"],

]

export const iluminacaoConfig = [
    // Terreo
   {
    id: "grupo01",
    modulo: "1",
    idx: "1",
    descricao: "Circuito 01",
    lightType: "normal",
    instances: [
      { x: 62.6, y: 36, width: 2.5, height: 5, circleNumber: 1 },
      { x: 62.6, y: 50.2, width: 2.5, height: 5, circleNumber: 1 }
    ]
  },
  {
    id: "grupo02",
    modulo: "1",
    idx: "2",
    descricao: "Circuito 02",
    lightType: "normal",
    instances: [
      { x: 65.4, y: 30.8, width: 2.5, height: 5, circleNumber: 2 },
      { x: 65.75, y: 45.4, width: 2.5, height: 5, circleNumber: 2 }
    ]
  },
  {
    id: "grupo03",
    modulo: "1",
    idx: "3",
    descricao: "Circuito 03",
    lightType: "normal",
    instances: [
      { x: 63.2, y: 60.8, width: 2.5, height: 5, circleNumber: 3 }
    ]
  },
  {
    id: "grupo04",
    modulo: "1",
    idx: "4",
    descricao: "Circuito 04",
    lightType: "normal",
    instances: [
      { x: 75.8, y: 27.7, width: 2.5, height: 5, circleNumber: 4 },
      { x: 76, y: 53, width: 2.5, height: 5, circleNumber: 4 }
    ]
  },
  {
    id: "grupo05",
    modulo: "1",
    idx: "5",
    descricao: "Circuito 05",
    lightType: "normal",
    instances: [
      { x: 72.4, y: 50.1, width: 2.5, height: 5, circleNumber: 5 }
    ]
  },
  {
    id: "grupo06",
    modulo: "1",
    idx: "6",
    descricao: "Circuito 06",
    lightType: "normal",
    instances: [
      { x: 75.7, y: 59.7, width: 2.5, height: 5, circleNumber: 6 }
    ]
  },
  {
    id: "grupo07",
    modulo: "1",
    idx: "7",
    descricao: "Circuito 07",
    lightType: "normal",
    instances: [
      { x: 73, y: 81.25, width: 2.5, height: 5, circleNumber: 7 }
    ]
  },
  {
    id: "grupo09",
    modulo: "2",
    idx: "1",
    descricao: "Circuito 09",
    lightType: "normal",
    instances: [
      { x: 71.3, y: 21.3, width: 2.5, height: 5, circleNumber: 9 }
    ]
  },
  {
    id: "grupo10",
    modulo: "2",
    idx: "2",
    descricao: "Circuito 10",
    lightType: "normal",
    instances: [
      { x: 78.5, y: 20, width: 2.5, height: 5, circleNumber: 10 },
      { x: 78.5, y: 40.8, width: 2.5, height: 5, circleNumber: 10 },
      { x: 78.55, y: 63.35, width: 2.5, height: 5, circleNumber: 10 }
    ]
  },
  {
    id: "grupo29",
    modulo: "4",
    idx: "5",
    descricao: "Circuito 29",
    lightType: "normal",
    instances: [
      { x: 73.15, y: 42.4, width: 2.5, height: 5, circleNumber: 29 }
    ]
  },
  {
    id: "grupo54",
    modulo: "7",
    idx: "6",
    descricao: "Circuito 54",
    lightType: "normal",
    instances: [
      { x: 4.3, y: 55, width: 2.5, height: 5, circleNumber: 54 }
    ]
  },
  {
    id: "grupo55",
    modulo: "7",
    idx: "7",
    descricao: "Circuito 55",
    lightType: "normal",
    instances: [
      { x: 3.25, y: 43.5, width: 2.5, height: 5, circleNumber: 55 }
    ]
  },
    {
    id: "grupo56",
    modulo: "10",
    idx: "8",
    descricao: "Circuito 56",
    lightType: "normal",
    instances: [
      { x: 0.25, y: 36.5, width: 2.5, height: 5, circleNumber: 56 }
    ]
  },
  {
    id: "grupo57",
    modulo: "8",
    idx: "1",
    descricao: "Circuito 57",
    lightType: "normal",
    instances: [
      { x: 8.25, y: 39.7, width: 2.5, height: 5, circleNumber: 57 },
      { x: 23.1, y: 35.7, width: 2.5, height: 5, circleNumber: 57 }
    ]
  },
  //Lazer
   {
    id: "grupo13",
    modulo: "2",
    idx: "5",
    descricao: "Circuito 13",
    lightType: "normal",
    instances: [
      { x: 81.35, y: 56, width: 2.5, height: 5, circleNumber: 13 }
    ]
  },
  {
    id: "grupo14",
    modulo: "2",
    idx: "6",
    descricao: "Circuito 14",
    lightType: "normal",
    instances: [
      { x: 67.65, y: 68.2, width: 2.5, height: 5, circleNumber: 14 }
    ]
  },
  {
    id: "grupo15",
    modulo: "2",
    idx: "7",
    descricao: "Circuito 15",
    lightType: "normal",
    instances: [
      { x: 79.5, y: 67.5, width: 2.5, height: 5, circleNumber: 15 }
    ]
  },
  {
    id: "grupo16",
    modulo: "2",
    idx: "8",
    descricao: "Circuito 16",
    lightType: "normal",
    instances: [
      { x: 68.35, y: 54.4, width: 2.5, height: 5, circleNumber: 16 }
    ]
  },
  {
    id: "grupo17",
    modulo: "3",
    idx: "1",
    descricao: "Circuito 17",
    lightType: "normal",
    instances: [
      { x: 81.1, y: 29.9, width: 2.5, height: 5, circleNumber: 17 }
    ]
  },
  {
    id: "grupo18",
    modulo: "3",
    idx: "2",
    descricao: "Circuito 18",
    lightType: "normal",
    instances: [
      { x: 76, y: 51, width: 2.5, height: 5, circleNumber: 18 },
      { x: 72, y: 32, width: 2.5, height: 5, circleNumber: 18 }
    ]
  },
  {
    id: "grupo19",
    modulo: "3",
    idx: "3",
    descricao: "Circuito 19",
    lightType: "normal",
    instances: [
      { x: 73, y: 20.8, width: 2.5, height: 5, circleNumber: 19 }
    ]
  },
  {
    id: "grupo23",
    modulo: "3",
    idx: "7",
    descricao: "Circuito 23",
    lightType: "normal",
    instances: [
      { x: 63.5, y: 18.5, width: 2.5, height: 5, circleNumber: 23 }
    ]
  },
  {
    id: "grupo26",
    modulo: "4",
    idx: "2",
    descricao: "Circuito 26",
    lightType: "normal",
    instances: [
      { x: 51, y: 16, width: 2.5, height: 5, circleNumber: 26 }
    ]
  },
  {
    id: "grupo27",
    modulo: "4",
    idx: "3",
    descricao: "Circuito 27",
    lightType: "normal",
    instances: [
      { x: 73, y: 6.5, width: 2.5, height: 5, circleNumber: 27 },
      { x: 81, y: 6.5, width: 2.5, height: 5, circleNumber: 27 }
    ]
  },
  {
    id: "grupo28",
    modulo: "4",
    idx: "4",
    descricao: "Circuito 28",
    lightType: "normal",
    instances: [
      { x: 76.6, y: 11.25, width: 2.5, height: 5, circleNumber: 28 }
    ]
  },
  {
    id: "grupo30",
    modulo: "4",
    idx: "6",
    descricao: "Circuito 30",
    lightType: "normal",
    instances: [
      { x: 16.15, y: 49.3, width: 2.5, height: 5, circleNumber: 30 },
      { x: 25.5, y: 49.7, width: 2.5, height: 5, circleNumber: 30 },
      { x: 25.5, y: 37.35, width: 2.5, height: 5, circleNumber: 30 },
      { x: 16.65, y: 34.05, width: 2.5, height: 5, circleNumber: 30 }
    ]
  },
  {
    id: "grupo31",
    modulo: "4",
    idx: "7",
    descricao: "Circuito 31",
    lightType: "normal",
    instances: [
      { x: 40, y: 48, width: 2.5, height: 5, circleNumber: 31 }
    ]
  },
  {
    id: "grupo32",
    modulo: "4",
    idx: "8",
    descricao: "Circuito 32",
    lightType: "normal",
    instances: [
      { x: 51, y: 22, width: 2.5, height: 5, circleNumber: 32 }
    ]
  },
  {
    id: "grupo33",
    modulo: "5",
    idx: "1",
    descricao: "Circuito 33",
    lightType: "normal",
    instances: [
      { x: 28.85, y: 51.35, width: 2.5, height: 5, circleNumber: 33 },
      { x: 39.5, y: 35, width: 2.5, height: 5, circleNumber: 33 },
      { x: 51.5, y: 28.5, width: 2.5, height: 5, circleNumber: 33 }
    ]
  },
  {
    id: "grupo35",
    modulo: "5",
    idx: "3",
    descricao: "Circuito 35",
    lightType: "normal",
    instances: [
      { x: 31.5, y: 31, width: 2.5, height: 5, circleNumber: 35 },
      { x: 45, y: 31, width: 2.5, height: 5, circleNumber: 35 },
      { x: 79, y: 82, width: 2.5, height: 5, circleNumber: 35 }
    ]
  },
  {
    id: "grupo36",
    modulo: "5",
    idx: "4",
    descricao: "Circuito 36",
    lightType: "normal",
    instances: [
      { x: 62.1, y: 70.15, width: 2.5, height: 5, circleNumber: 36 },
      { x: 62.5, y: 61.55, width: 2.5, height: 5, circleNumber: 36 },
      { x: 58, y: 34, width: 2.5, height: 5, circleNumber: 36 },
      { x: 49.75, y: 33.15, width: 2.5, height: 5, circleNumber: 36 }
    ]
  },
  {
    id: "grupo37",
    modulo: "5",
    idx: "5",
    descricao: "Circuito 37",
    lightType: "normal",
    instances: [
      { x: 60.4, y: 75.7, width: 2.5, height: 5, circleNumber: 37 },
      { x: 60, y: 59, width: 2.5, height: 5, circleNumber: 37 },
      { x: 52.5, y: 53, width: 2.5, height: 5, circleNumber: 37 }
    ]
  },
  {
    id: "grupo38",
    modulo: "5",
    idx: "6",
    descricao: "Circuito 38",
    lightType: "normal",
    instances: [
    { x: 0, y: 500, width: 0, height: 0, circleNumber: 38 }
    ]
  },
  {
    id: "grupo39",
    modulo: "5",
    idx: "7",
    descricao: "Circuito 39",
    lightType: "normal",
    instances: [
      { x: 54.25, y: 38, width: 2.5, height: 5, circleNumber: 39 }
    ]
  },
  //Apoio
    {
    id: "grupo51",
    modulo: "7",
    idx: "3",
    descricao: "Circuito 51",
    lightType: "normal",
    instances: [
      { x: 13.7, y: 13.9, width: 2.5, height: 5, circleNumber: 51 }
    ]
  },
  {
    id: "grupo52",
    modulo: "7",
    idx: "4",
    descricao: "Circuito 52",
    lightType: "normal",
    instances: [
      { x: 52.9, y: 61.5, width: 2.5, height: 5, circleNumber: 52 },
      { x: 48.4, y: 13.7, width: 2.5, height: 5, circleNumber: 52 }
    ]
  },
  //Rooftop
    {
    id: "grupo42",
    modulo: "6",
    idx: "2",
    descricao: "Circuito 42",
    lightType: "normal",
    instances: [
      { x: 4.4, y: 31.5, width: 2.5, height: 5, circleNumber: 42 },
      { x: 17.7, y: 31.5, width: 2.5, height: 5, circleNumber: 42 }
    ]
  },
  {
    id: "grupo43",
    modulo: "6",
    idx: "3",
    descricao: "Circuito 43",
    lightType: "normal",
    instances: [
      { x: 65.75, y: 32.5, width: 2.5, height: 5, circleNumber: 43 },
      { x: 52.35, y: 32.9, width: 2.5, height: 5, circleNumber: 43 }
    ]
  },
  {
    id: "grupo44",
    modulo: "6",
    idx: "4",
    descricao: "Circuito 44",
    lightType: "normal",
    instances: [
      { x: 26.2, y: 58, width: 2.5, height: 5, circleNumber: 44 },
      { x: 43.85, y: 69.5, width: 2.5, height: 5, circleNumber: 44 },
      { x: 26.2, y: 69.5, width: 2.5, height: 5, circleNumber: 44 },
      { x: 43.7, y: 58.6, width: 2.5, height: 5, circleNumber: 44 },
    ]
  },
  {
    id: "grupo45",
    modulo: "6",
    idx: "5",
    descricao: "Circuito 45",
    lightType: "normal",
    instances: [
      { x: 34.7, y: 29.5, width: 2.5, height: 5, circleNumber: 45 }

    ]
  },
  {
    id: "grupo46",
    modulo: "6",
    idx: "6",
    descricao: "Circuito 46",
    lightType: "normal",
    instances: [
      { x: 34.75, y: 52.85, width: 2.5, height: 5, circleNumber: 46 }
    ]
  }
];

// Função útil para obter informações de ON/OFF para cada circuito
export const getCircuitOnOffValues = (circuitNumber) => {
  const circuitIndex = circuitNumber - 1;
  if (circuitIndex < 0 || circuitIndex >= iluminacaoConfig.length) {
    return null;
  }
  
  const circuit = iluminacaoConfig[circuitIndex];
  return {
    descricao: circuit.descricao,
    onValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "OFF" })
  };
};